import { NgModule } from "@angular/core";
import { Routes, RouterModule} from "@angular/router";
import { AuthGuard } from "./auth.guard";
import { LoginGuard } from "./login.guard";
import { RefGuard } from "./ref.guard";
import {LoadPageResolve} from "./loadPageResolve";
import { ChangePasswordComponent } from "./public/change-password";
import { LoginComponent,RegistrationComponent,RestoreComponent,ActivateComponent } from "./public";
import { SidebarComponent } from "./sidebar";
import { UserGuard } from "./user.guard";
import { ProfileComponent } from "./profile";
import { PushNotificationComponent,PushNotificationEditorComponent, PushNotificationEditorModule } from "./push-notification";
import { UsersProfileComponent } from "./users-profile";
import { AllUsersComponent} from "./admin/all-users";
import { CreateUserComponent } from "./admin/create-user";
import { CreateAdminComponent } from "./superadmin/create-admin";
import { StatisticsComponent } from "./statistics/statistics.component"
import { StatisticsNotificationComponent } from './statistics/statistics.notification/statistic.notification.component';
import { StatisticsSubscriptionComponent } from './statistics/statistics.subscription/statistic.subscription.component';
import { DomainsComponent } from "./domains";
import { NewdomainComponent } from "./newdomain"
import { ReferralComponent } from "./referral"
import { FinanceComponent } from "./finance"
import { GeoComponent } from "./geo"
import { GeoEditorComponent } from "./geo/geo-editor"
import { PushNotifSectionComponent } from "./push-notif-section"
import { SettingsComponent } from "./settings"
import { LegalDomainComponent } from "./legal-domain"
import { StatisticsGroupDateComponent } from "./statistics/statistitic.group.date/statistitic.group.date.component";



export const routes: Routes = [
    {
        path: "",
        //pathMatch: "full",
        component: LoginComponent,
        canActivate: [LoginGuard]
    },
    {
        path: "app/login",
        component: LoginComponent,
        canActivate: [LoginGuard]
    },
    {
        path: "app/registration",
        component: RegistrationComponent,
        canActivate: [LoginGuard]
    },
    {
        path: "app/change-password",
        component: ChangePasswordComponent
    },
    {
      path: "app/restore",
      component: RestoreComponent
    },
    {
      path: "app/activate",
      component: ActivateComponent
    },
    {
        path: "app",
        component: SidebarComponent,
        resolve:[LoadPageResolve],
        children: [
            // {
            //     path: "profile",
            //     component: ProfileComponent,
            //     data: { roles: '0,1,2' },
            //     canActivate: [UserGuard]
            // },
            {
                path: "domains",
                component: DomainsComponent,
                data: { roles: '2' },
                canActivate: [UserGuard]
            },
            {
                path: "referral",
                component: ReferralComponent,
                data: { roles: '2' },
                canActivate: [UserGuard]
            },
            {
                path: "newdomain",
                component: NewdomainComponent,
                data: { roles: '2' },
                canActivate: [UserGuard]
            },
            {
                path: "geo",
                component: GeoComponent,
                data: { roles: '0,1,2' },
                canActivate: [UserGuard]
            },
            {
                path: "newgeo",
                component: GeoEditorComponent,
                data: { roles: '0,1,2' },
                canActivate: [UserGuard]
            },
            {
                path: "geoeditor/:id",
                component: GeoEditorComponent,
                data: { roles: '0,1,2' },
                canActivate: [UserGuard]
            },
            {
                path: "push-notif-section",
                component: PushNotifSectionComponent,
                data: { roles: '2' },
                canActivate: [UserGuard]
            },
            {
              path: "statistics",
              component:StatisticsComponent,
              data: {roles: '0,1,2' },
              canActivate: [UserGuard],
              children: [
                  { path: '', redirectTo: 'app/statistics/statistic-subscription', pathMatch: 'full' },
                  {
                      path: "statistic-notification",
                      component:StatisticsNotificationComponent,
                      data: { roles: '0,1,2' },
                      canActivate: [UserGuard]
                  },
                  {
                      path:"statistic-subscription",
                      component:StatisticsSubscriptionComponent,
                      data: { roles: '0,1,2' },
                      canActivate: [UserGuard]
                  },
                  {
                    path:"statistic-group-date",
                    component:StatisticsGroupDateComponent,
                    data: { roles: '0,1,2' },
                    canActivate: [UserGuard]
                }
              ]
          },

            // {
            //     path: "finance",
            //     component: FinanceComponent,
            //     data: { roles: '0,1,2' },
            //     canActivate: [UserGuard],
            // },
            {
                path: "settings",
                component: SettingsComponent,
                data: { roles: '2' },
                canActivate: [UserGuard]
            },
            {
                path: "editdomain/:id",
                component: NewdomainComponent,
                data: { roles: '0,1,2' },
                canActivate: [UserGuard]
            },
            {
                path: "all-users",
                component: AllUsersComponent,
                data: { roles: '2' },
                canActivate: [UserGuard]
            },
            {
                path: "legal-domain",
                component: LegalDomainComponent,
                data: { roles: '2' },
                canActivate: [UserGuard]
            },
            {
                path: "create-user",
                component: CreateUserComponent,
                data: { roles: '1,2' },
                canActivate: [UserGuard]
            },
            // {
            //     path: "create-admin",
            //     component: CreateAdminComponent,
            //     data: { roles: '1,2' },
            //     canActivate: [UserGuard]
            // },
            {
                path: "users-profile/:id",
                component: UsersProfileComponent,
                data: { roles: '1,2' },
                canActivate: [UserGuard]
            },
            {
              path: "push-notification",
              component: PushNotificationComponent,
              data: { roles: '0,1,2' },
              canActivate: [UserGuard]
            },
            {
              path: "push-notification-create",
              component: PushNotificationEditorComponent,
              data: { roles: '0,1,2',sectionHead :"Создание уведомления" },
              canActivate: [UserGuard]

            },
            {
              path: "push-notification-editor/:id",
              component: PushNotificationEditorComponent,
              data: { roles: '0,1,2',sectionHead :"Редактирование уведомления"},
              canActivate: [UserGuard],
            }

        ],
        canActivate: [AuthGuard]
    },
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts